import React from 'react';
import { Box, Typography } from '@mui/material';
import SectionCard from '../SectionCard';
import { FormSectionProps } from '../../types';
import { sectionThemes } from '../../styles';

const PlantCare: React.FC<FormSectionProps> = ({ 
  plant
}) => {
  return (
    <SectionCard 
      title="Plant Care" 
      icon={<i className={sectionThemes.plantCare.iconName} style={{ marginRight: '8px' }} />}
      theme={{ color: sectionThemes.plantCare.color }}
    >
      <Box sx={{ p: 2 }}>
        <Typography>
          Plant Care section is under construction.
        </Typography>
      </Box>
    </SectionCard>
  );
};

export default React.memo(PlantCare);
